<template>
  <b-dropdown
    size="sm"
    right
    variant="default"
    toggle-class="text-decoration-none"
    no-caret
    ref="dropdown"
  >
    <template slot="button-content"
      ><b-button variant="primary" size="sm"><i class="fa fa-cogs"></i> Endre</b-button></template
    >
    <b-dropdown-form class="pl-3 pr-3">
      <b-form-group
        label="Antall plasser"
        label-for="dropdown-form-email"
        @submit.prevent="submitForm"
      >
        <b-form-input
          id="dropdown-form-email"
          size="sm"
          type="number"
          :min="event.bookings.length"
          v-model="participants"
        ></b-form-input>
      </b-form-group>
      <b-dropdown-divider></b-dropdown-divider>
      <b-button type="submit" block variant="primary" size="sm" @click.prevent="submitForm()">
        Lagre
      </b-button>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
  props: ['event'],
  data() {
    return {
      rootUrl: process.env.VUE_APP_API_URL,
      participants: this.event.participants,
    };
  },
  methods: {
    ...mapActions({
      getAvailableDates: 'bookings/getAvailableDates',
    }),
    submitForm() {
      let origParticipants = this.event.participants;
      const url = `${this.rootUrl}/bookings/dates/${this.event.id}/participants`;
      axios.put(url, { participants: this.participants }).then(res => {
        this.$refs.dropdown.hide(true);
        this.getAvailableDates();
        this.$bvToast.toast(
          `Antallet plasser er nå endret fra ${origParticipants} til ${this.participants}`,
          {
            variant: 'success',
            title: 'Antallet plasser er nå endret',
            autoHideDelay: 5000,
          }
        );
      });
    },
  },
  watch: {
    participants: function (newVal, old) {
      if (newVal < this.event.bookings.length) {
        this.participants = this.event.bookings.length;
      }
    },
  },
};
</script>